import { AsyncComponent } from '@frontend/components/mobile';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

const AuthenticationQr = lazy(() => import('./authentication-qr/authentication-qr.component'));
const CurrentLocationPage = lazy(() => import('./current-location/current-location-page.component'));
const DevicePreferences = lazy(() => import('./device-preferences/device-preferences.component'));
const PreferredPrinterPage = lazy(() => import('./device-preferences/preferred-printer-page/preferred-printer-page.component'));
const LanguagePage = lazy(() => import('./language-page/language-page.component'));
const LanguageSelectPage = lazy(() => import('./language-page/language-select-page/language-select-page.component'));
const UserLanguageSelectPage = lazy(() => import('./language-page/user-language-select-page/user-language-select-page.component'));
const NotificationsPage = lazy(() => import('./notifications-page/notifications-page.component'));
const PrefferedLocationPage = lazy(() => import('./preffered-location-page/preffered-location-page.component'));
const Privacy = lazy(() => import('./privacy/privacy.component'));
const Profile = lazy(() => import('./profile.component'));
const ReleaseNotes = lazy(() => import('./release-notes/release-notes.component'));
const SecurityPage = lazy(() => import('./security-page/security-page.component'));
const UserPreferences = lazy(() => import('./user-preferences/user-preferences.component'));

export function ProfileRoutes() {
    return (
        <Route path='profile'>
            <Route
                index
                element={
                    <AsyncComponent>
                        <Profile />
                    </AsyncComponent>
                }
            />
            <Route
                path='notifications'
                element={
                    <AsyncComponent>
                        <NotificationsPage />
                    </AsyncComponent>
                }
            />
            <Route path='user-preferences'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <UserPreferences />
                        </AsyncComponent>
                    }
                />

                <Route
                    path='preferred-location'
                    element={
                        <AsyncComponent>
                            <PrefferedLocationPage />
                        </AsyncComponent>
                    }
                />
            </Route>

            <Route path='device-preferences'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <DevicePreferences />
                        </AsyncComponent>
                    }
                />

                <Route
                    path='current-location'
                    element={
                        <AsyncComponent>
                            <CurrentLocationPage />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='preferred-printer'
                    element={
                        <AsyncComponent>
                            <PreferredPrinterPage />
                        </AsyncComponent>
                    }
                />
            </Route>

            <Route path='language'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <LanguagePage />
                        </AsyncComponent>
                    }
                />

                <Route
                    path='user'
                    element={
                        <AsyncComponent>
                            <UserLanguageSelectPage />
                        </AsyncComponent>
                    }
                />

                <Route
                    path='device'
                    element={
                        <AsyncComponent>
                            <LanguageSelectPage />
                        </AsyncComponent>
                    }
                />
            </Route>

            <Route
                path='privacy'
                element={
                    <AsyncComponent>
                        <Privacy />
                    </AsyncComponent>
                }
            />
            <Route path='security'>
                <Route
                    index
                    element={
                        <AsyncComponent>
                            <SecurityPage />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='auth-qr'
                    element={
                        <AsyncComponent>
                            <AuthenticationQr />
                        </AsyncComponent>
                    }
                />
            </Route>

            <Route
                path='release-notes'
                element={
                    <AsyncComponent>
                        <ReleaseNotes />
                    </AsyncComponent>
                }
            />
        </Route>
    );
}
